import { assertNever } from "../../../util/assertNever";
import { CommonColumnOperators, StringColumnOperators } from "../enum.filterOperators";
import { GenericTableFilterType, StringFilterType } from "../type.genericTableQuery";
import type { FilterMapper } from "./interface.filterMapper";
export class StringFilterMapper implements FilterMapper {
  toQuery({ filter }: StringFilterType): undefined | string {
    const option = filter.option;
    switch (option) {
      case StringColumnOperators.STARTS_WITH: {
        const stringStartsWith = filter.value;
        return `${StringColumnOperators.STARTS_WITH}$-$${stringStartsWith}`;
      }
      case StringColumnOperators.ENDS_WITH: {
        const stringEndsWith = filter.value;
        return `${StringColumnOperators.ENDS_WITH}$-$${stringEndsWith}`;
      }
      case StringColumnOperators.CONTAINS: {
        const stringContains = filter.value;
        return `${StringColumnOperators.CONTAINS}$-$${stringContains}`;
      }
      case StringColumnOperators.EXACT: {
        const stringExact = filter.value;
        return `${StringColumnOperators.EXACT}$-$${stringExact}`;
      }
      case StringColumnOperators.IN: {
        const stringArrayValues = filter.value;
        return stringArrayValues ? `${StringColumnOperators.IN}$-$${stringArrayValues.join(",")}` : undefined;
      }
      case CommonColumnOperators.VALUE_EXISTS: {
        const missingValue = filter.value;
        return `${CommonColumnOperators.VALUE_EXISTS}$-$${missingValue}`;
      }
      default:
        assertNever(option);
    }
  }

  fromQuery(value: string): StringFilterType {
    const [columnOperator, filterValue] = value.split("$-$");
    if (columnOperator === undefined || filterValue === undefined) {
      throw new Error("missing filter value or option");
    }
    const option = this.parseStringColumnOperator(columnOperator);

    switch (option) {
      case CommonColumnOperators.VALUE_EXISTS:
        return {
          type: GenericTableFilterType.STRING,
          filter: { option, value: filterValue === "true" },
        };
      case StringColumnOperators.STARTS_WITH:
      case StringColumnOperators.ENDS_WITH:
      case StringColumnOperators.CONTAINS:
      case StringColumnOperators.EXACT:
        return {
          type: GenericTableFilterType.STRING,
          filter: { option, value: filterValue },
        };
      case StringColumnOperators.IN:
        return {
          type: GenericTableFilterType.STRING,
          filter: { option, value: filterValue.split(",").filter((value) => value.length > 0) },
        };
      default:
        assertNever(option);
    }
  }

  private parseStringColumnOperator(option: string): CommonColumnOperators | StringColumnOperators {
    const allOptions = [...Object.values(StringColumnOperators), ...Object.values(CommonColumnOperators)];
    if (allOptions.includes(option as CommonColumnOperators | StringColumnOperators)) {
      return option as CommonColumnOperators | StringColumnOperators;
    }
    throw new Error(`Invalid string filter option: ${option}`);
  }
}
